import {default as UploadIcon} from '@mui/icons-material/Upload';

export default UploadIcon;